import * as React from 'react';

import { Button, Modal, Text } from '@components/common';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => void;
  title: string;
  message: string;
  isLoading?: boolean;
}

export const ScreenerNavigationModal: React.FC<Props> = ({
  isOpen,
  onCancel,
  onContinue,
  title,
  message,
  isLoading
}) => {
  if (!isOpen) return null;

  return (
    <Modal onClose={onCancel} size='sm'>
      <Text h='500' bold className='mb-4 text-lg'>
        {title}
      </Text>
      <Text className='mb-6 text-sm text-gray-700'>{message}</Text>

      <div className='flex justify-end space-x-3'>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button primary onClick={onContinue} disabled={isLoading} loading={isLoading}>
          Continue
        </Button>
      </div>
    </Modal>
  );
};
